import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2986352793/src/src/app/ui/common/side-menu.tsx");
